import { useCrmSuiteOwnershipLevel } from '../inventory/useProductInventory';
import { useProductDetailsForArray } from '../product/useProductDetails';

/**
 * Hook to determine if you own the starter platform and are trying to buy a pro level product
 */
export const useStarterPlatformUnbundling = (purchaseRequest, purchaseMotion) => {
  var _productDetails$produ;
  const {
    crmSuiteLevel,
    loading: crmSuiteLevelLoading,
    error: crmSuiteLevelError
  } = useCrmSuiteOwnershipLevel();
  const ownsStarterPlatform = crmSuiteLevel === 'STARTER';
  const {
    productDetails,
    loading: productDetailsLoading,
    error: productDetailsError
  } = useProductDetailsForArray({
    productApiNames: purchaseRequest.products.map(product => product.productApiName)
  });
  const isTryingToBuyProLevelProduct = Object.values((_productDetails$produ = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ !== void 0 ? _productDetails$produ : {}).some(product => product.productLevel === 'PROFESSIONAL');
  return {
    eligibleForUnbundling: purchaseMotion === 'BUY_TOUCHLESS' && ownsStarterPlatform && isTryingToBuyProLevelProduct,
    loading: crmSuiteLevelLoading || productDetailsLoading,
    error: crmSuiteLevelError || productDetailsError
  };
};